import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'react-modal';

import useScrollPercentage from '../hooks/useScrollPercentage';
import { useScrollDisable } from '../hooks/useScrollDisable';
import { DocumentsModalFooter } from './DocumentsModalFooter';
import { DocumentsCarousel } from './DocumentsCarousel';
import { DocumentsModalHeader } from './DocumentsModalHeader';
import { useDocumentTimeout } from '../hooks/useDocumentTimeout';
import { useScrollInfoModal } from '../hooks/useScrollInfoModal';
import { DocumentsRadioButton } from './DocumentsRadioButton';
import 'react-virtualized/styles.css';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';

const DocumentsModal = ({
    documentsList,
    showDocumentModal,
    onDocumentRead,
    onDocumentAccepted,
    onSaveDocumentAcceptance,
    handleClose,
    aDocumentWasNotAccepted,
    updateRadioButtonDocumentList,
    setLastScrollTop,
    lastScrollTop,
    currentDocumentIndex,
    setCurrentDocumentIndex
}) => {
    const [isSavingDocumentAcceptance, setIsSavingDocumentAcceptance] = useState(false);
    const currentDocument = useMemo(() => documentsList?.[currentDocumentIndex], [documentsList, currentDocumentIndex]);
    const areAlldocumentsAccepted = useMemo(
        () => documentsList.every(document => document.isAccepted),
        [documentsList]
    );
    const isDocumentAccepted = currentDocument && currentDocument.isAccepted;
    const isDocumentRead = currentDocument && currentDocument.isRead;

    useEffect(() => {
        setCurrentDocumentIndex(0);
    }, [showDocumentModal]);



    useEffect(() => {
        if (isDocumentAccepted && documentsList.length > 0) {
            const nextDocumentIndex = currentDocumentIndex + 1;
            if (nextDocumentIndex === documentsList.length) {
                handleClose(scrollPercentage);
            }
            onDocumentAccepted(documentsList[currentDocumentIndex]);
            setIsSavingDocumentAcceptance(false);
        }
        if (aDocumentWasNotAccepted) {
            setIsSavingDocumentAcceptance(false);
        }
    }, [isDocumentAccepted, aDocumentWasNotAccepted])


    useScrollDisable({ condition: showDocumentModal });
    const [pdfContainerRef, scrollPercentage] = useScrollPercentage();

    const { renderScrollInfoModal, openScrollInfoModal, scrollInfoModalShowed } = useScrollInfoModal({
        onClickCancelButton: e => handleClose(e, scrollPercentage),
    });

    const { resetTimeoutFunction, stopTimeoutFunction } = useDocumentTimeout(
        {
            startCondition: !isDocumentRead && !isDocumentAccepted && showDocumentModal && !scrollInfoModalShowed,
            callback: () => {
                openScrollInfoModal('vista timeout');
            },
            timeLapse: 15000,
        },
        [showDocumentModal]
    );

    const recordTagPrecontractualModal = (tagEvent, customData = {}) => {
    };

    const handleScroll = ({ documentIndex, isAtBottom }) => {
        const document = documentsList[documentIndex];
        if (!isAtBottom) {
            resetTimeoutFunction();
        } else if (!document.isRead) {
            !__CONTACT_CENTER__ && onDocumentRead(document);
            stopTimeoutFunction();
        }
    };

    const handleConfirm = e => {
        e.preventDefault();
        onSaveDocumentAcceptance(currentDocument);

        handleClose(e, scrollPercentage);
    };

    const handleOnContinue = e => {
        e.preventDefault();
        setCurrentDocumentIndex(prevState => prevState + 1);
        onSaveDocumentAcceptance(currentDocument);
    };

    const handleClickContinueDisabled = e => {
        e.preventDefault();
        stopTimeoutFunction();
        openScrollInfoModal('vista click');
    };

    const handleClickCloseButton = e => {
        e.preventDefault();
        handleClose(e, scrollPercentage);
    };

    const handleClickCancelButton = e => {
        e.preventDefault();
        openScrollInfoModal('vista click');
        stopTimeoutFunction();
    };

    return (
        <Modal
            isOpen={showDocumentModal}
            style={{
                overlay: {
                    zIndex: 2101,
                },
            }}>
            <div>
                <div className='documents__modal__box-inside'>
                    <div className="documents__modal__container">
                        <DocumentsModalHeader
                            documentsList={documentsList}
                            currentDocumentIndex={currentDocumentIndex}
                        />
                        <DocumentsCarousel
                            documentsList={documentsList}
                            currentDocumentIndex={currentDocumentIndex}
                            pdfContainerRef={pdfContainerRef}
                            onScroll={handleScroll}
                            recordTagPrecontractualModal={recordTagPrecontractualModal}
                            setLastScrollTop={setLastScrollTop}
                            lastScrollTop={lastScrollTop}
                            onDocumentRead={onDocumentRead}

                        />

                        {__CONTACT_CENTER__ && isPrintOfficeMode() && isDocumentRead &&
                            <DocumentsRadioButton
                                currentDocument={currentDocument}
                                updateRadioButtonDocumentList={updateRadioButtonDocumentList}
                            />
                        }
                        <DocumentsModalFooter
                            areAlldocumentsAccepted={areAlldocumentsAccepted}
                            isCurrentDocumentAcepted={isDocumentAccepted}
                            isCurrentDocumentRead={isDocumentRead}
                            isSavingDocumentAcceptance={isSavingDocumentAcceptance}
                            currentDocument={currentDocument}
                            onClose={handleClickCloseButton}
                            onCancel={handleClickCancelButton}
                            onConfirm={handleConfirm}
                            onContinue={handleOnContinue}
                            onContinueDisabled={handleClickContinueDisabled}
                        />
                    </div>
                </div>
                {renderScrollInfoModal()}
            </div>
        </Modal>
    );
};
export default DocumentsModal;